// Asyncstorage
export const SET_ITEM_SUCCESS = 'SET_ITEM_SUCCESS';
export const GET_ITEM_SUCCESS = 'GET_ITEM_SUCCESS';
export const GET_ITEM_FAIL = 'GET_ITEM_FAIL';

// Muser
// user
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const GENERAL_SETTINGS = 'GENERAL_SETTINGS';
export const MOUNT_COMPONENT = "MOUNT_COMPONENT"
export const GENERAL_SETTINGS_FAIL = 'GENERAL_SETTINGS_FAIL';

export const SCANPACK_SETTINGS = 'SCANPACK_SETTINGS';
export const SCANPACK_SETTINGS_FAIL = 'SCANPACK_SETTINGS_FAIL';

export const GET_BOTH_SETTINGS = 'GET_BOTH_SETTINGS';
export const GET_BOTH_SETTINGS_FAIL = 'GET_BOTH_SETTINGS_FAIL';

export const USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';
export const USER_INFO_SUCCESS_FAIL = 'USER_INFO_SUCCESS_FAIL';
export const SEND_PASSWORD_RESET_EMAIL = 'SEND_PASSWORD_RESET_EMAIL';
export const SEND_PASSWORD_RESET_EMAIL_FAIL = 'SEND_PASSWORD_RESET_EMAIL_FAIL';
export const IS_EMAIL_SEND = 'IS_EMAIL_SEND';
export const IS_BUG_SUPPORT_POPUP_OPEN = 'IS_BUG_SUPPORT_POPUP_OPEN';
export const GET_ALL_USERS = 'GET_ALL_USERS';

// url
export const UPDATE_URL = 'UPDATE_URL';
export const GET_URL = 'GET_URL';

// scanpack
export const CLICK_SCAN = 'CLICK_SCAN';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const UPDATE_PRODUCT_FAIL = 'UPDATE_PRODUCT_FAIL';
export const SEARCH_SCANPACK_ORDER = 'SEARCH_SCANPACK_ORDER';
export const SEARCH_SCANPACK_ORDER_FAIL = 'SEARCH_SCANPACK_ORDER_FAIL';
export const SUBMIT_LOG = 'SUBMIT_LOG';
export const SUBMIT_LOG_FAIL = 'SUBMIT_LOG_FAIL';
export const SCANPACK_BUG_REPORT = 'SCANPACK_BUG_REPORT';
export const SCANPACK_BUG_REPORT_FAIL = 'SCANPACK_BUG_REPORT_FAIL';
export const DASHBOARD_DATA = 'DASHBOARD_DATA';
export const RESET_SCANPACK_ORDER = 'RESET_SCANPACK_ORDER';
export const SHOW_DUPLICATE_PICK_WARNING = 'SHOW_DUPLICATE_PICK_WARNING';
export const HIDE_DUPLICATE_PICK_WARNING = 'HIDE_DUPLICATE_PICK_WARNING';
export const SHOW_DUPLICATE_PICK_TOAST = 'SHOW_DUPLICATE_PICK_TOAST';
export const HIDE_DUPLICATE_PICK_TOAST = 'HIDE_DUPLICATE_PICK_TOAST';
export const ON_DEMAND_IMPORT_EVENT = 'ON_DEMAND_IMPORT_EVENT';
export const CLEAR_ON_DEMAND_IMPORT_EVENT = 'CLEAR_ON_DEMAND_IMPORT_EVENT';
export const ADD_PENDING_CHANGE = 'ADD_PENDING_CHANGE';
export const REMOVE_PENDING_CHANGE = 'REMOVE_PENDING_CHANGE';
export const CLEAR_PENDING_CHANGES = 'CLEAR_PENDING_CHANGES';

// Camera Scanner
export const SET_CAMERA_OPEN = 'SET_CAMERA_OPEN';
export const SET_CAMERA_CLOSED = 'SET_CAMERA_CLOSED';
export const SET_PREFERRED_CAMERA = 'SET_PREFERRED_CAMERA';
export const RESTORE_CAMERA_STATE = 'RESTORE_CAMERA_STATE';
export const SAVE_PENDING_CHANGES = 'SAVE_PENDING_CHANGES';
export const SAVE_PRODUCT_DATA = 'SAVE_PRODUCT_DATA';
export const SAVE_PRODUCT_DATA_FAIL = 'SAVE_PRODUCT_DATA_FAIL';
export const CLEAR_SAVED_PRODUCT_DATA = 'CLEAR_SAVED_PRODUCT_DATA';

export const OFFLINE_DATA = 'OFFLINE_DATA'
export const OFFLINE_MESSAGE = 'OFFLINE_MESSAGE'

export const UPDATE_AWAITING_COUNT_FROM_IMPORT = 'UPDATE_AWAITING_COUNT_FROM_IMPORT';
export const CLEAR_IMPORT_AWAITING_COUNT = 'CLEAR_IMPORT_AWAITING_COUNT';

// menu
export const IS_OPEN = 'IS_OPEN';
export const IS_UNMOUNT = 'IS_UNMOUNT';

// listDisplay
export const IS_LIST_MODE = 'IS_LIST_MODE';

//haptics mode
export const IS_HAPTICS_MODE = 'IS_HAPTICS_MODE';

// swap upc and location
export const IS_SWAP = 'IS_SWAP';

// notification popUp
export const OPEN_NOTIFICATION = 'OPEN_NOTIFICATION';

// product
export const PRODUCT_DETAIL = 'PRODUCT_DETAIL';
export const PRODUCT_DETAIL_FAIL = 'PRODUCT_DETAIL_FAIL';
export const GET_ALL_PRODUCT = 'GET_ALL_PRODUCT';
export const GET_ALL_PRODUCT_FAIL = 'GET_ALL_PRODUCT_FAIL';

export const GET_SEARCH_PRODUCT = 'GET_SEARCH_PRODUCT';
export const CLEAR_SEARCH_PRODUCT = 'CLEAR_SEARCH_PRODUCT';
export const GET_SEARCH_PRODUCT_FAIL = 'GET_SEARCH_PRODUCT_FAIL';

export const UPDATE_PRODUCT_INFO = 'UPDATE_PRODUCT_INFO';
export const UPDATE_PRODUCT_INFO_FAIL = 'UPDATE_PRODUCT_INFO_FAIL';
export const UPDATE_PRODUCT_ALIAS = 'UPDATE_PRODUCT_ALIAS';
export const UPDATE_PRODUCT_ALIAS_FAIL = 'UPDATE_PRODUCT_ALIAS_FAIL';

export const UPDATE_PRODUCT_LIST = 'UPDATE_PRODUCT_LIST';
export const UPDATE_PRODUCT_LIST_FAIL = 'UPDATE_PRODUCT_LIST_FAIL';
export const IS_LOADING = 'IS_LOADING';
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const ADD_PDF = 'ADD_PDF';
export const GET_PDFS = 'GET_PDFS';
export const IS_PRODUCT_CREATED = 'IS_PRODUCT_CREATED';
export const IS_PRODUCT_UPDATED = 'IS_PRODUCT_UPDATED';
export const IS_PRODUCT_LOADING = 'IS_PRODUCT_LOADING';
export const ARE_PRODUCTS_UPDATED = 'ARE_PRODUCTS_UPDATED';
// headers
export const ORDER_BACK_BUTTON = 'ORDER_BACK_BUTTON';

// order
export const IS_PRODUCT_BARCODE_ADDED = 'IS_PRODUCT_BARCODE_ADDED';

// order tags
export const GET_ORDERS_TAGS = 'GET_ORDERS_TAGS';


//  order
export const ORDER_LIST = 'ORDER_LIST';
//Multibox changes.
export const ORDER_DETAIL_LOADER ='ORDER_DETAIL_LOADER';
export const ORDER_LIST_FAIL = 'ORDER_LIST_FAIL';
export const ORDER_DETAIL = 'ORDER_DETAIL';
export const ORDER_DETAIL_FAIL = 'ORDER_DETAIL_FAIL';
export const SEARCH_ORDER = 'SEARCH_ORDER';
export const SEARCH_ORDER_COUNT = 'SEARCH_ORDER_COUNT';
export const SEARCH_ORDER_FAIL = 'SEARCH_ORDER_FAIL';
export const REMOVE_BOX_ITEMS = 'REMOVE_BOX_ITEMS';
export const REMOVE_BOX = 'REMOVE_BOX';
export const ADD_BOX = 'ADD_BOX';
export const PRINT_SLIP_MULTIBOX = 'PRINT_SLIP_MULTIBOX';
export const UPDATE_ORDER_QUANTITY = 'UPDATE_ORDER_QUANTITY';
export const UPDATE_ORDER_QUANTITY_FAIL = 'UPDATE_ORDER_QUANTITY_FAIL';

export const ADD_ORDER_ITEMS = 'ADD_ORDER_ITEMS';
export const ADD_ORDER_ITEMS_FAIL = 'ADD_ORDER_ITEMS_FAIL';

export const REMOVE_ORDER_ITEMS = 'REMOVE_ORDER_ITEMS';
export const REMOVE_ORDER_ITEMS_FAIL = 'REMOVE_ORDER_ITEMS_FAIL';

export const UPDATE_ORDER_INFO = 'UPDATE_ORDER_INFO';
export const UPDATE_ORDER_INFO_FAIL = 'UPDATE_ORDER_INFO_FAIL';

export const ADD_ORDER_IMAGE = 'ADD_ORDER_IMAGE';
export const ADD_ORDER_SUCCESS = 'ADD_ORDER_SUCCESS';
export const ADD_ORDER_FAIL = 'ADD_ORDER_FAIL';
export const ADD_ORDER_IMAGE_FAIL = 'ADD_ORDER_IMAGE_FAIL';
export const ADD_ORDER_IMAGE_LOADING = 'ADD_ORDER_IMAGE_LOADING';
export const ADD_ORDER_IMAGE_CLEAR = 'ADD_ORDER_IMAGE_CLEAR';
export const REMOVE_PACKING_IMAGE_LOADING = 'REMOVE_PACKING_IMAGE_LOADING';
export const REMOVE_PACKING_IMAGE_DONE = 'REMOVE_PACKING_IMAGE_DONE';
export const REMOVE_PACKING_IMAGE_FAIL = 'REMOVE_PACKING_IMAGE_FAIL';

export const ADD_ITEM_BOX = 'ADD_ITEM_BOX';
export const CREATE_ORDER = 'CREATE_ORDER';
export const IS_ORDER_CREATED = 'IS_ORDER_CREATED';
export const ARE_ORDERS_UPDATED = 'ARE_ORDERS_UPDATED';

// import order
export const IMPORT_ORDER_FAIL = 'IMPORT_ORDER_FAIL';
export const IMPORT_ORDER_SUCCESS = 'IMPORT_ORDER_SUCCESS';
export const IMPORT_ORDER_STATUS_SUCCESS = 'IMPORT_ORDER_STATUS_SUCCESS';
export const IMPORT_ORDER_STATUS_FAIL = 'IMPORT_ORDER_STATUS_FAIL';
export const FULL_ORDER_SCAN_CHECK ='FULL_ORDER_SCAN_CHECK';
export const DETECT_ORDERS_DISCREPANCIES ='DETECT_ORDERS_DISCREPANCIES';

export const ALL_KIT_PRODUCT = 'ALL_PRODUCT';
export const ALL_KIT_PRODUCT_FAIL = 'ALL_PRODUCT_FAIL';

export const GET_KIT_PRODUCT = 'GET_KIT_PRODUCT';
export const GET_KIT_PRODUCT_FAIL = 'GET_KIT_PRODUCT_FAIL';

export const REMOVE_KIT_PRODUCT = 'REMOVE_KIT_PRODUCT';
export const REMOVE_KIT_PRODUCT_FAIL = 'REMOVE_KIT_PRODUCT_FAIL';

export const ADD_IMAGE = 'ADD_IMAGE';
export const ADD_HTML_IMAGE = 'ADD_HTML_IMAGE';
export const ADD_IMAGE_FAIL = 'ADD_IMAGE_FAIL';

export const RECORD_EXCEPTION = 'RECORD_EXCEPTION';
export const CLEAR_EXCEPTION = 'CLEAR_EXCEPTION';

export const GET_SHIPMENT_ID_SUCCESS = '';
export const GET_SHIPMENT_ID_FAIL = '';

//Shipping Label

export const CARRIER_LOADING = 'CARRIER_LOADING';

export const GET_SS_LABEL = 'GET_SS_LABEL';
export const GET_SS_LABEL_FAIL = 'GET_SS_LABEL_FAIL';

export const FETCH_REAL_TIME_RATES_SELECTED = 'FETCH_REAL_TIME_RATES_SELECTED';
export const FETCH_REAL_TIME_RATES_SELECTED_FAIL =
  'FETCH_REAL_TIME_RATES_SELECTED_FAIL';

export const FETCH_REAL_TIME_RATES = 'FETCH_REAL_TIME_RATES';
export const FETCH_REAL_TIME_RATES_FAIL = 'FETCH_REAL_TIME_RATES_FAIL';

export const UPDATE_ORDER_ADDRESS = 'UPDATE_ORDER_ADDRESS';
export const UPDATE_ORDER_ADDRESS_FAIL = 'UPDATE_ORDER_ADDRESS_FAIL';

export const SET_CARRIER_VISIBILITY = 'SET_CARRIER_VISIBILITY';
export const SET_CARRIER_VISIBILITY_FAIL = 'SET_CARRIER_VISIBILITY_FAIL';

export const SET_RATE_VISIBILITY = 'SET_RATE_VISIBILITY';
export const SET_RATE_VISIBILITY_FAIL = 'SET_RATE_VISIBILITY_FAIL';

export const CREATE_SS_LABEL = 'CREATE_SS_LABEL';
export const CREATE_SS_LABEL_FAIL = 'CREATE_SS_LABEL_FAIL';

export const SET_LABEL_SHORTCUT = 'SET_LABEL_SHORTCUT';
export const SET_LABEL_SHORTCUT_FAIL = 'SET_LABEL_SHORTCUT_FAIL';

export const PURCHASE_LOADING = 'PURCHASE_LOADING';
export const PURCHASE_LOADING_DONE = 'PURCHASE_LOADING_DONE';

export const SET_CONTRACTED_CARRIER = 'SET_CONTRACTED_CARRIER';
export const SET_CONTRACTED_CARRIER_FAIL = 'SET_CONTRACTED_CARRIER_FAIL';

export const SET_PRESETS = 'SET_PRESETS';
export const SET_PRESETS_FAIL = 'SET_PRESETS_FAIL';


export const SET_STATUS_MULTI_BOX = "SET_STATUS_MULTI_BOX"

export const SET_CURRRENT_ORDER = "SET_CURRRENT_ORDER"

export const CHECK_IMPORT_ORDER_STATUS_SUCCESS = "CHECK_IMPORT_ORDER_STATUS_SUCCESS"
export const CHECK_IMPORT_ORDER_STATUS_FAIL = "CHECK_IMPORT_ORDER_STATUS_FAIL"

//  order tag Priority

export const GET_ORDER_TAG_PRIORITY = 'GET_ORDER_TAG_PRIORITY';
export const GET_ORDER_TAG_PRIORITY_FAIL = 'GET_ORDER_TAG_PRIORITY_FAIL';
export const GET_ORDER_TAG_PRIORITY_LOADING = 'GET_ORDER_TAG_PRIORITY_LOADING';
export const GET_ORDER_TAG_PRIORITY_ERROR = 'GET_ORDER_TAG_PRIORITY_ERROR';
export const UPDATE_ORDER_TAG_PRIORITY = 'UPDATE_ORDER_TAG_PRIORITY';
export const UPDATE_ORDER_TAG_PRIORITY_FAIL = 'UPDATE_ORDER_TAG_PRIORITY_FAIL';
export const CREATE_ORDER_TAG_PRIORITY = 'CREATE_ORDER_TAG_PRIORITY';
export const CREATE_ORDER_TAG_PRIORITY_FAIL = 'CREATE_ORDER_TAG_PRIORITY_FAIL';
export const UPDATE_ORDER_TAG_PRIORITY_POSITION = 'UPDATE_ORDER_TAG_PRIORITY_POSITION';
export const DELETE_ORDER_TAG_PRIORITY = 'DELETE_ORDER_TAG_PRIORITY';

export const UPDATE_ORDER_TAG_PRIORITY_POSITION_LOADING = 'UPDATE_ORDER_TAG_PRIORITY_POSITION_LOADING';
export const UPDATE_ORDER_TAG_PRIORITY_POSITION_ERROR = 'UPDATE_ORDER_TAG_PRIORITY_POSITION_ERROR';
export const ADD_TAG = 'ADD_TAG';

export const STATISTICS_LIST = 'STATISTICS_LIST';
export const STATISTICS_LIST_FAIL = 'STATISTICS_LIST_FAIL';

export const STATISTICS_TODAY_VS_YESTERDAY_LIST =
  'STATISTICS_TODAY_VS_YESTERDAY_LIST';
export const STATISTICS_TODAY_VS_YESTERDAY_LIST_FAIL =
  'STATISTICS_TODAY_VS_YESTERDAY_LIST_FAIL';

export const STATISTICS_WITHIN15MIN_LIST = 'STATISTICS_WITHIN15MIN_LIST';
export const STATISTICS_WITHIN15MIN_LIST_FAIL =
  'STATISTICS_WITHIN15MIN_LIST_FAIL';

export const STATISTICS_WEEKLY_LIST = 'STATISTICS_WEEKLY_LIST';
export const STATISTICS_WEEKLY_LIST_FAIL = 'STATISTICS_WEEKLY_LIST_FAIL';
export const STATISTICS_ITEMS_PER_MINUTE_LIST =
  'STATISTICS_ITEMS_PER_MINUTE_LIST';
export const STATISTICS_ITEMS_PER_MINUTE_LIST_FAIL =
  'STATISTICS_ITEMS_PER_MINUTE_LIST_FAIL';
export const STATISTICS_ITEMS_PER_HOUR_LIST =
  'STATISTICS_ITEMS_PER_HOUR_LIST';
export const STATISTICS_ITEMS_PER_HOUR_LIST_FAIL =
  'STATISTICS_ITEMS_PER_HOUR_LIST_FAIL';
export const STATISTICS_SCAN_SCORE_LIST = 'STATISTICS_SCAN_SCORE_LIST';
export const STATISTICS_SCAN_SCORE_LIST_FAIL = 'STATISTICS_SCAN_SCORE_LIST_FAIL';

export const PRODUCTION_GOAL = 'PRODUCTION_GOAL';
export const PRODUCTION_GOAL_FAIL = 'PRODUCTION_GOAL_FAIL';

export const SCAN_SCORE_UPDATE = 'SCAN_SCORE_UPDATE';

export const FETCH_SAVED_FILTERS_SUCCESS = 'FETCH_SAVED_FILTERS_SUCCESS';
export const FETCH_SAVED_FILTERS_FAIL = 'FETCH_SAVED_FILTERS_FAIL';
export const CREATE_SAVED_FILTER_SUCCESS = 'CREATE_SAVED_FILTER_SUCCESS';
export const UPDATE_SAVED_FILTER_SUCCESS = 'UPDATE_SAVED_FILTER_SUCCESS';
export const DELETE_SAVED_FILTER_SUCCESS = 'DELETE_SAVED_FILTER_SUCCESS';

// scan to cart
export const FETCH_CARTS = 'FETCH_CARTS';
export const ADD_CART = 'ADD_CART_SUCCESS';
export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_CART_LOCAL = 'UPDATE_CART_LOCAL';
export const DELETE_CART = 'DELETE_CART';
export const SET_ACTIVE_CART = 'SET_ACTIVE_CART';
export const SET_CART_ORDERS = 'SET_CART_ORDERS';
export const SET_NEXT_PICK_ITEM = 'SET_NEXT_PICK_ITEM';
export const SET_TOTE_ASSIGNMENTS = 'SET_TOTE_ASSIGNMENTS';
export const SET_UNSCANNED_ITEMS = 'SET_UNSCANNED_ITEMS';
export const SET_SCANNED_ITEMS = 'SET_SCANNED_ITEMS';
export const SET_IS_CART_VIEW = 'SET_IS_CART_VIEW';
export const SET_PICKING_SESSION = 'SET_PICKING_SESSION';
export const SET_IS_NOT_EMPTY_CART = 'SET_IS_NOT_EMPTY_CART';
export const SET_CART_ASSIGNMENT_DETAILS = 'SET_CART_ASSIGNMENT_DETAILS';
export const SET_CART_ASSIGNMENT_TOAST = 'SET_CART_ASSIGNMENT_TOAST';
export const SET_CART_ASSIGNMENT_DETAILS_PROMPT = 'SET_CART_ASSIGNMENT_DETAILS_PROMPT';
export const SET_ZONE_ACCESS_MODAL_FOR_CART = 'SET_ZONE_ACCESS_MODAL_FOR_CART';
export const SET_PREVIOUS_SCAN_INFO = 'SET_PREVIOUS_SCAN_INFO';
export const SET_NON_ASSIGNMENT_DETAILS = 'SET_NON_ASSIGNMENT_DETAILS';
export const SET_RFO_NO_ORDERS = 'SET_RFO_NO_ORDERS';
export const SET_SHOW_CART_READY_BANNER = 'SET_SHOW_CART_READY_BANNER';
export const SET_OUT_OF_STOCK_PROMPT = 'SET_OUT_OF_STOCK_PROMPT';
export const SET_CART_TOAST_MESSAGE = 'SET_CART_TOAST_MESSAGE';
export const SET_PREVIOUS_NEXT_PICK_ITEMS = 'SET_PREVIOUS_NEXT_PICK_ITEMS';
export const SET_NOT_FULL_FILLED_ITEMS = 'SET_NOT_FULL_FILLED_ITEMS';
export const SET_LAST_CART_INPUT = 'SET_LAST_CART_INPUT';


export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER';
export const SET_SCAN_TO_CART_LOADING = 'SET_SCAN_TO_CART_LOADING';
export const SET_SUGGESTED_ITEM = 'SET_SUGGESTED_ITEM';
export const SET_BARCODE_INPUT = 'SET_BARCODE_INPUT';
export const SET_PASS_SCAN = 'SET_PASS_SCAN';
export const SET_SCAN_SUCCESS = 'SET_SCAN_SUCCESS';
export const SET_SCAN_ERROR = 'SET_SCAN_ERROR';
export const SET_MAIN_INPUT_FOCUS = 'SET_MAIN_INPUT_FOCUS';
export const SET_PROMPT = 'SET_PROMPT';
export const SET_SERIAL_RECORD_ONE_INPUT = 'SET_SERIAL_RECORD_ONE_INPUT';
export const SET_SERIAL_RECORD_TWO_INPUT = 'SET_SERIAL_RECORD_TWO_INPUT';
export const SET_SCANNING_LOGS = 'SET_SCANNING_LOGS';
export const SET_CART_SCAN_COMPLETE = 'SET_CART_SCAN_COMPLETE';
export const SET_IS_EMPTY_CART = 'SET_IS_EMPTY_CART';
export const SET_CURRENT_CART_SCAN_COMPLETE = 'SET_CURRENT_CART_SCAN_COMPLETE';
export const SET_PLACED_CONFIRMATION = 'SET_PLACED_CONFIRMATION';
export const SET_CART_TYPE_SCAN_STATE = 'SET_CART_TYPE_SCAN_STATE';
export const SET_ACTIVE_TOTE = 'SET_ACTIVE_TOTE';
export const SET_FOCUSED_ORDER = 'SET_FOCUSED_ORDER';
export const CLEAR_FOCUSED_ORDER = 'CLEAR_FOCUSED_ORDER';

export const SET_SCAN_PACK_CURRENT_ORDER = 'SET_SCANPACK_CURRENT_ORDER';
export const SET_SCAN_PACK_BARCODE_INPUT = 'SET_SCANPACK_BARCODE_INPUT';
export const SET_SCAN_PACK_MAIN_INPUT_FOCUS = 'SET_SCANPACK_MAIN_INPUT_FOCUS';
export const SET_SCAN_PACK_CURRENT_ITEM = 'SET_SCANPACK_CURRENT_ITEM';
export const SET_SCAN_PACK_PROMPT = 'SET_SCAN_PACK_PROMPT';
export const SET_SCAN_PACK_SCAN_SUCCESS = 'SET_SCAN_PACK_SCAN_SUCCESS';
export const SET_SCAN_PACK_SCAN_ERROR = 'SET_SCAN_PACK_SCAN_ERROR';
export const SET_TYPE_SCAN_STATE = 'SET_TYPE_SCAN_STATE';
export const SET_TYPE_SCAN_ADJACENT_SCANS = 'SET_TYPE_SCAN_ADJACENT_SCANS';
export const ADD_SCAN_PACK_LOCAL_LOG = 'ADD_SCAN_PACK_LOCAL_LOG';
export const SET_ACTIVE_BOX_INDEX = 'SET_ACTIVE_BOX_INDEX';
export const SET_MULTI_BOX_ALERT = 'SET_MULTI_BOX_ALERT';
export const SET_PRINT_SLIP_NOTICE = 'SET_PRINT_SLIP_NOTICE';
export const CLEAR_PRINT_SLIP_NOTICE = 'CLEAR_PRINT_SLIP_NOTICE';
export const SET_SCAN_PACK_LOADING = 'SET_SCAN_PACK_LOADING';
export const SET_ORDER_COMPLETE = 'SET_ORDER_COMPLETE';
export const SET_ORDER_COMPLETE_ACTION = 'SET_ORDER_COMPLETE_ACTION';
export const SET_POST_SCAN_PIPELINE = 'SET_POST_SCAN_PIPELINE';
export const SET_POST_SCAN_TRACKING_INPUT = 'SET_POST_SCAN_TRACKING_INPUT';
export const SET_ALIAS_STATE = 'SET_ALIAS_STATE';
export const SET_SHIPMENT_STATE = 'SET_SHIPMENT_STATE';
export const SET_NAVIGATION_SOURCE = 'SET_NAVIGATION_SOURCE';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_WMS_ZERO_PENDING = 'SET_WMS_ZERO_PENDING';
export const SET_BOX_CHAMP_STATE = 'SET_BOX_CHAMP_STATE';
export const RESET_BOX_CHAMP_STATE = 'RESET_BOX_CHAMP_STATE';

export const UPLOAD_SOUND_REQUEST = 'UPLOAD_SOUND_REQUEST';
export const UPLOAD_SOUND_SUCCESS = 'UPLOAD_SOUND_SUCCESS';
export const UPLOAD_SOUND_FAIL = 'UPLOAD_SOUND_FAIL';

export const FETCH_SOUND_SUCCESS = 'FETCH_SOUND_SUCCESS';
export const FETCH_SOUND_FAIL = 'FETCH_SOUND_FAIL';
export const REMOVE_SOUND_FAIL = 'REMOVE_SOUND_FAIL';
export const REMOVE_SOUND_SUCCESS = 'REMOVE_SOUND_SUCCESS';
//  Inventory Reports
export const FETCH_INVENTORY_REPORTS_SUCCESS = 'FETCH_INVENTORY_REPORTS_SUCCESS';
export const FETCH_INVENTORY_REPORTS_FAIL = 'FETCH_INVENTORY_REPORTS_FAIL';
export const DELETE_INVENTORY_REPORT_SUCCESS = 'DELETE_INVENTORY_REPORT_SUCCESS';
export const CREATE_INVENTORY_REPORT_SUCCESS = 'CREATE_INVENTORY_REPORT_SUCCESS';
export const CREATE_INVENTORY_REPORT_FAILURE = 'CREATE_INVENTORY_REPORT_FAILURE';
export const UPDATE_INVENTORY_REPORT = 'UPDATE_INVENTORY_REPORT'
export const FETCH_ARCHIVED_INVENTORY_REPORTS_SUCCESS = 'FETCH_ARCHIVED_INVENTORY_REPORTS_SUCCESS'
export const FETCH_SHOPIFY_LOCATIONS_SUCCESS = 'FETCH_SHOPIFY_LOCATIONS_SUCCESS';
export const FETCH_SHOPIFY_LOCATIONS_FAILURE = 'FETCH_SHOPIFY_LOCATIONS_FAILURE';

// Rules Engine
export const RULES_FETCH_REQUEST = 'RULES_FETCH_REQUEST';
export const RULES_FETCH_SUCCESS = 'RULES_FETCH_SUCCESS';
export const RULES_FETCH_FAILURE = 'RULES_FETCH_FAILURE';
export const RULE_SAVE_REQUEST = 'RULE_SAVE_REQUEST';
export const RULE_SAVE_SUCCESS = 'RULE_SAVE_SUCCESS';
export const RULE_SAVE_FAILURE = 'RULE_SAVE_FAILURE';
export const RULE_DELETE_SUCCESS = 'RULE_DELETE_SUCCESS';
export const RULE_TOGGLE_SUCCESS = 'RULE_TOGGLE_SUCCESS';
export const RULES_REORDER_SUCCESS = 'RULES_REORDER_SUCCESS';
export const RULES_STORES_FETCH_REQUEST = 'RULES_STORES_FETCH_REQUEST';
export const RULES_STORES_FETCH_SUCCESS = 'RULES_STORES_FETCH_SUCCESS';
export const RULES_STORES_FETCH_FAILURE = 'RULES_STORES_FETCH_FAILURE';

// BoxChamp
export const BOXCHAMP_VALIDATE_REQUEST = 'BOXCHAMP_VALIDATE_REQUEST';
export const BOXCHAMP_VALIDATE_SUCCESS = 'BOXCHAMP_VALIDATE_SUCCESS';
export const BOXCHAMP_VALIDATE_FAILURE = 'BOXCHAMP_VALIDATE_FAILURE';
export const BOXCHAMP_QUEUE_REQUEST = 'BOXCHAMP_QUEUE_REQUEST';
export const BOXCHAMP_QUEUE_COMPLETE = 'BOXCHAMP_QUEUE_COMPLETE';
export const BOXCHAMP_RESET = 'BOXCHAMP_RESET';

export const SCANPACK_ORDER_WINDOW_NAME_PREFIX = 'gpx_scanpack_order:';

export const ITEMS_PER_MINUTE_WINDOW_DAYS = 6;

export const PF_SET_TOTE_SET = 'PF_SET_TOTE_SET';
export const PF_SET_INPUT = 'PF_SET_INPUT';
export const PF_SET_STAGE = 'PF_SET_STAGE';
export const PF_SET_SCAN_RESULT = 'PF_SET_SCAN_RESULT';
export const PF_CONFIRM_TOTE = 'PF_CONFIRM_TOTE';
export const PF_SET_ORDER_COMPLETE = 'PF_SET_ORDER_COMPLETE';
export const PF_SET_SCAN_SUCCESS = 'PF_SET_SCAN_SUCCESS';
export const PF_SET_SCAN_ERROR = 'PF_SET_SCAN_ERROR';
export const PF_SET_LOADING = 'PF_SET_LOADING';
export const PF_SET_NOTICE = 'PF_SET_NOTICE';
export const PF_SET_PROMPT = 'PF_SET_PROMPT';
export const PF_SET_FOCUS = 'PF_SET_FOCUS';
export const PF_SET_POSTSCAN = 'PF_SET_POSTSCAN';
export const PF_RESET = 'PF_RESET';

// Feature flags
export const SET_FEATURE_FLAG = 'SET_FEATURE_FLAG';
export const LOT_METADATA_REPORT_READY = 'LOT_METADATA_REPORT_READY';
export const LOT_METADATA_REPORT_CLEAR = 'LOT_METADATA_REPORT_CLEAR';